import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/icons/logoWhite.svg";

function ViewerHeader({ onOpenContent }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();
  const path = location.pathname || "/";
  const isHome = path === "/";

  const openContent = (type) => {
    setMenuOpen(false);
    onOpenContent?.(type);
  };

  useEffect(() => {
    function onDocClick(e) {
      if (!menuOpen) return;
      if (!navRef.current) return;
      if (!navRef.current.contains(e.target)) setMenuOpen(false);
    }
    function onKey(e) {
      if (e.key === "Escape") setMenuOpen(false);
    }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [menuOpen]);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const navMenu = (
    <nav
      className={`header-nav${menuOpen ? " is-open" : ""}`}
      aria-label="Principal"
    >
      <button
        type="button"
        className="header-nav-link"
        onClick={() => openContent("faq")}
      >
        <span className="header-nav-icon" aria-hidden>
          <i className="bi bi-question-circle" />
        </span>
        <span className="header-nav-text">Preguntas frecuentes</span>
      </button>

      <button
        type="button"
        className="header-nav-link"
        onClick={() => openContent("documentos")}
      >
        <span className="header-nav-icon" aria-hidden>
          <i className="bi bi-journal-text" />
        </span>
        <span className="header-nav-text">Documentos de interés</span>
      </button>

      <button
        type="button"
        className="header-nav-link"
        onClick={() => openContent("glosario")}
      >
        <span className="header-nav-icon" aria-hidden>
          <i className="bi bi-book" />
        </span>
        <span className="header-nav-text">Glosario</span>
      </button>

      <button
        type="button"
        className="header-nav-link"
        onClick={() => openContent("recursos")}
      >
        <span className="header-nav-icon" aria-hidden>
          <i className="bi bi-mortarboard" />
        </span>
        <span className="header-nav-text">Recursos educativos</span>
      </button>
    </nav>
  );

  const homeLink = (
    <Link
      to="/"
      onClick={() => setMenuOpen(false)}
      className={`header-home-link${isHome ? " is-active" : ""}`}
      aria-label="Inicio"
    >
      <i className="bi bi-house-door" aria-hidden />
      <span>Inicio</span>
    </Link>
  );

  const menuToggle = (
    <button
      type="button"
      className="nav-toggle"
      aria-label="Abrir menú"
      aria-haspopup="true"
      aria-expanded={menuOpen}
      onClick={() => setMenuOpen((v) => !v)}
    >
      <span className="nav-toggle__bar" />
      <span className="nav-toggle__bar" />
      <span className="nav-toggle__bar" />
    </button>
  );

  const sgcLogo = (
    <div className="sgc-logo">
      <a
        href="https://sgc.gov.co/"
        className="logo"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => setMenuOpen(false)}
      >
        <img src={logo} alt="Servicio Geológico Colombiano" />
      </a>
    </div>
  );

  return (
    <header className="header header--home">
      <div className="header-left" ref={navRef}>
        {menuToggle}
        {homeLink}
        {navMenu}
      </div>
      <div className="header-right">{sgcLogo}</div>
    </header>
  );
}

export default ViewerHeader;
